import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=159aeacb&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('159aeacb')) {
      api.createRecord('159aeacb', component.options)
    } else {
      api.reload('159aeacb', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=159aeacb&", function () {
      api.rerender('159aeacb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-85s25qlC5ou5P/JS/comp/ImgFallback2.vue"
export default component.exports